import { motion } from "framer-motion";
import { STEPS, IMAGES } from "../lib/site";

export default function Expect() {
  return (
    <section id="expect" data-testid="session-expectation-section" className="relative bg-[#18181B] text-[#FAF7F2] py-24 sm:py-32 lg:py-40 grain">
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <p className="eyebrow label text-[#C5A059] mb-6">What to expect</p>
            <h2 className="font-display text-4xl sm:text-5xl leading-[1.05] tracking-tight">
              One hour, entirely <span className="italic text-[#C5A059]">yours</span>.
            </h2>
            <p className="mt-6 text-[#FAF7F2]/70 text-lg leading-relaxed max-w-md">
              Every session follows a rhythm designed to meet you where you are — and move you, gently, forward.
            </p>
            <motion.div
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="mt-10 overflow-hidden rounded-3xl border border-[#FAF7F2]/10"
            >
              <img src={IMAGES.reformer} alt="Focused Pilates practice" className="w-full h-80 object-cover" />
            </motion.div>
          </div>

          <div className="lg:col-span-7 space-y-2">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, x: 24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                data-testid={`expect-step-${s.n}`}
                className="flex gap-6 p-7 rounded-2xl hover:bg-[#FAF7F2]/[0.04] transition-colors duration-400 border border-transparent hover:border-[#FAF7F2]/10"
              >
                <span className="font-mono-pp text-[#C5A059] text-sm pt-2">{s.n}</span>
                <div>
                  <h3 className="font-display text-2xl sm:text-3xl mb-2">{s.title}</h3>
                  <p className="text-[#FAF7F2]/65 text-base sm:text-lg leading-relaxed max-w-xl">{s.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
